import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import { BaseNumApp } from "./BaseNumApp";

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<BaseNumApp />
	</React.StrictMode>
);
